import axios from 'axios';
import { API_BASE_URL, STORAGE_KEYS } from '../utils/constants';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // Handle 401 Unauthorized
      if (error.response.status === 401) {
        const requestUrl = error.config?.url || '';
        const isAuthRequest =
          requestUrl.includes('/auth/login') ||
          requestUrl.includes('/auth/register') ||
          requestUrl === '/auth/login' ||
          requestUrl === '/auth/register';

        if (!isAuthRequest) {
          // Clear token and redirect to login
          localStorage.removeItem(STORAGE_KEYS.TOKEN);
          localStorage.removeItem(STORAGE_KEYS.USER);
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }
      }

      // Extract error message
      const responseData = error.response.data;
      if (responseData?.message) {
        error.message = responseData.message;
      } else if (responseData?.error) {
        error.message = responseData.error;
      }
      error.responseData = responseData;
    } else if (error.request) {
      // Request was made but no response received
      error.message =
        'Cannot connect to server. Please check if the backend is running.';
      error.isNetworkError = true;
    }

    return Promise.reject(error);
  }
);

export default api;
